module.exports = __webpack_public_path__ + "static/media/4.14.aa4d6499.png";